import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNameList'
})
export class FormatNameListPipe implements PipeTransform {
  transform(names: string[]): string {
    if (!names || names.length === 0) {
      return '';
    }

    if (names.length === 1) {
      return names[0];
    }

    if (names.length === 2) {
      return names.join(' e ');
    }

    const lastCommaSeparatedNames = names.slice(0, -1).join(', ');
    const lastItem = names[names.length - 1];

    return `${lastCommaSeparatedNames} e ${lastItem}`;
  }
}